<template>
  <b-layout :colors="$site.colors" :header-title="$t('pages.gift.card.customer.title')" :header-back-route="{ path: '/gift/card' }" :breadcrumbs="breadcrumbs">
    <b-container class="mt-12">
      <b-summary>
        <template #summary>
          <gift-card-detail />
        </template>

        <div>
          <customer-select :title="$t('pages.gift.card.customer.yourDetails')" @selected="selectedCustomer" />
        </div>
      </b-summary>
    </b-container>
  </b-layout>
</template>

<script>
import CustomerSelect from '@/components/customer/elements/Select.vue'
import GiftCardDetail from '@/components/gift/elements/CardDetail.vue'

definePageMeta({
  tabs: ['giftCard']
});

export default defineNuxtComponent({
  components: {
    CustomerSelect,
    GiftCardDetail
  },
  async asyncData () {
    const route = useRoute()
    const giftStore = useGiftStore()
    
    await giftStore.setFromUrlQuery(route.query)

    return {}
  },
  computed: {
    breadcrumbs () {
      return [
        { text: this.$site.tabs.giftCard.name, to: { path: '/gift' } },
        { text: this.$site.location.title + ' Gift Card', to: { path: '/gift/card' } },
        { text: this.$t('pages.gift.card.customer.title'), active: true }
      ]
    }
  },
  methods: {
    async selectedCustomer ({ customer }) {
      await this.$store.dispatch('gift/setCustomer', customer)
      const urlQuery = this.$store.getters['gift/urlQuery']

      this.$router.push({ path: '/gift/card/confirm', query: urlQuery })
    }
  }
})
</script>
